import { render, staticRenderFns } from "./newStaff.vue?vue&type=template&id=21727ad0&scoped=true"
import script from "./newStaff.vue?vue&type=script&lang=js"
export * from "./newStaff.vue?vue&type=script&lang=js"
import style0 from "./newStaff.vue?vue&type=style&index=0&id=21727ad0&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21727ad0",
  null
  
)

export default component.exports